import { useState, useEffect, useMemo } from 'react'

import API from '../../../../api/api'
import { getEventTypeOptions } from '../helpers'

export const useEventTypeOptions = (userData) => {
  const [eventTypes, setEventTypes] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const isManagerOrAdmin = ['Manager', 'Administrator'].includes(userData.user.role)

  const eventTypeOptions = useMemo(() => {
    return eventTypes.length ? getEventTypeOptions(eventTypes) : []
  }, [eventTypes])

  const fetchEventTypes = async () => {
    try {
      setIsLoading(true)
      const data = await API.getTrainingTypes()
      setEventTypes(data || [])
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isManagerOrAdmin) {
      fetchEventTypes()
    }
  }, [])

  return { eventTypeOptions, isLoading }
}
